<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="审核状态" prop="examineStatus">
                <a-select v-model="queryParam.examineStatus" :placeholder="'请选择'">
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option value="0">待审核</a-select-option>
                  <a-select-option value="1">已通过</a-select-option>
                  <a-select-option value="2">已驳回</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="证件图片" prop="idPicture">
                  <a-input v-model="queryParam.idPicture" placeholder="请输入证件图片,多个使用逗号隔开" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="审核原因" prop="examineReason">
                  <a-input v-model="queryParam.examineReason" placeholder="请输入审核原因" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['profession:authentication:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a :disabled="record.examineStatus !== 0" v-hasPermi="['profession:authentication:edit']"
             @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit"/>审核
          </a>
          <a-divider type="vertical" v-hasPermi="['profession:authentication:remove']"/>
          <a @click="handleDelete(record)" v-hasPermi="['profession:authentication:remove']">
            <a-icon type="delete"/>删除
          </a>
        </span>
        <span slot="examineStatus" slot-scope="text, record">
          <a-tag v-if="record.examineStatus === 0" color="orange">待审核</a-tag>
          <a-tag v-else-if="record.examineStatus === 1" color="green">已通过</a-tag>
          <a-tag v-else-if="record.examineStatus === 2" color="red">已驳回</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="idPicture" slot-scope="text, record">
    <img v-for="pic in record.idPicture.split(',')" v-if="record.idPicture" v-viewer :src="pic"
         preview="图片" style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;"/>
      </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {delAuthentication, pageAuthentication} from '@/api/profession/authentication'
import CreateForm from './modules/CreateForm'
import {tableMixin} from '@/store/table-mixin'

export default {
  name: 'Authentication',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        professionId: null,
        idPicture: null,
        expirationDate: null,
        examineStatus: '',
        examineReason: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '师傅名称',
          dataIndex: 'masterName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '工种名称',
          dataIndex: 'professionName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '证件图片',
          dataIndex: 'idPicture',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'idPicture'}
        },
        {
          title: '到期时间',
          dataIndex: 'expirationDate',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '审核状态',
          dataIndex: 'examineStatus',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'examineStatus' }
        },
        {
          title: '审核原因',
          dataIndex: 'examineReason',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '提交时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    if (!(this.$route.query && this.$route.query.id)) {
      this.getList()
    }
  },
  computed: {
  },
  watch: {
    '$route.query.id': {
      handler (id) {
        this.openDetailFromRoute(id)
      },
      immediate: true
    }
  },
  methods: {
    openDetailFromRoute (id) {
      if (id == null || id === '') {
        return
      }
      const status = this.$route.query.examineStatus != null ? this.$route.query.examineStatus : this.$route.query.status
      if (status !== undefined && status !== null && status !== '') {
        const n = parseInt(status, 10)
        if (!Number.isNaN(n)) {
          this.queryParam.examineStatus = n
        }
      }
      this.queryParam.pageNum = 1
      this.getList()
      this.$nextTick(() => {
        if (this.$refs.createForm) {
          this.$refs.createForm.handleUpdate({ id }, undefined)
        }
        this.clearRouteDetailIdQuery()
      })
    },
    clearRouteDetailIdQuery () {
      const q = { ...(this.$route.query || {}) }
      if (!q.id) {
        return
      }
      delete q.id
      this.$router.replace({ path: this.$route.path, query: q }).catch(() => {})
    },
    /** 查询工种认证列表 */
    getList () {
      this.loading = true
     pageAuthentication(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        professionId: undefined,
        idPicture: undefined,
        expirationDate: undefined,
        examineStatus: undefined,
        examineReason: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delAuthentication(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('profession/profession-authentication/export', {
            ...that.queryParam
          }, `工种认证_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
